import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { TwapOrder } from '@/store/orders/algoOrders/state.ts';

export const SavedTwapOrderValidator = arkScope.type({
  type: "'Twap+Order'",
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    clientWay: "'buy' | 'sell'",
    'notional?': 'number',
    notionalCurrencyIndex: 'CurrencyChoice',
    'limitPrice?': 'number',
    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      'tiering?': 'string',
    },
    isNdf: 'boolean',
    liquidityPool: 'string[]',
    ndfFixingSource: 'string?',
    ndfFixingDate: 'string?',
    'tenor?': 'string',
    startDate: {
      isNow: 'boolean',
      'date?': 'string',
      'time?': 'string',
    },
    expiryDate: {
      goodTillDate: 'boolean',
      'date?': 'string',
      'time?': 'string',
    },

    clippingMode: "'Automatic' | 'Manual' | 'Incremental' | 'Decremental' | 'Splayed'",
    clipSize: 'number?',
    randomize: 'boolean',
    spreadCapture: 'boolean',

    'notificationEmails?': 'string[]',
    isReadyToSubmit: 'boolean',
    'clockOffset?': 'number',
    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  clientId: 'number?',
});
export type SavedTwapOrder = typeof SavedTwapOrderValidator.infer;

export const SavedTwapOrder = {
  fromFxTwapOrder: (fxTile: TwapOrder, tileId: string): SavedTwapOrder => ({
    type: 'Twap+Order',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
